<mat-form-field  [floatLabel]="'never'" [ngClass]="customClass">
  <mat-select  [ngClass]="customClass" #selectDropdown [(value)] = "selectedValue" (keydown.ArrowDown)="openDropdown()" (keydown.Enter)="$event.stopImmediatePropagation()" (keydown.ArrowUp)="$event.stopImmediatePropagation()" (keydown.ArrowLeft)="$event.stopImmediatePropagation()" (keydown.ArrowRight)="$event.stopImmediatePropagation()" (change)="setOption($event)" [placeholder]="placeholderLabel" [disableOptionCentering]="true">
    <!-- search added -->
    @if (search) {
      <div class="mat-select-search-inner"
        [ngClass]="{'mat-select-search-inner-multiple': matSelect.multiple}">
        <input matInput
          class="mat-select-search-input notranslate"
          #searchSelectInput
          (keydown)="_handleKeydown($event)"
          [(ngModel)]="searchText"
          (input)="searchText"
          (ngModelChange)="inputChanged($event)"
          [placeholder]="'Search'"
          autocomplete="off"
          />
        @if (searchText) {
          <button id="select-search" mat-icon-button
            aria-label="Clear"
            (click)="_reset(true)"
            class="mat-select-search-clear">
            <i class="fas fa-times appIcon" aria-hidden="true"></i>
          </button>
        }
      </div>
    }
    @if ((noEntriesFoundLabel && filteredList.length === 0 && !emptyResults && !isSearching)) {
      <div
        class="mat-select-search-no-entries-found">
        {{noEntriesFoundLabel}}
      </div>
    }
    @if (searchingLabel && isSearching) {
      <div
        class="mat-select-search-no-entries-found">
        {{searchingLabel}}
      </div>
    }
    <!-- search end -->
    @if (!isSearching) {
      <div class="selectionOptions" [ngStyle]="{'max-height': displayKey == 'scheduleName' ? '190px' : '230px'}" #dropDownOptions>
        @for (item of filteredList; track item) {
          <mat-option class="hide-checkbox" id="{{'select-'+ displayKey?item[displayKey]:item}}" [value]="valueKey?item[valueKey]:item"  [ngClass] ="{'notranslate':disableTranslation,'indeterminate-state': selectedValues.length > 0 && selectedValues.length != data.length && item[valueKey] == 'all' }" (click)="toggleSelection(item)">
            {{displayKey?item[displayKey]:item}}
          </mat-option>
        }
      </div>
    }
    @if (showSelectVal) {
      @if (selectedValues.length) {
        <div class="divider"></div>
      }
      <div class="selectedOptionsList">
        @for (item of selectedValues; track item) {
          @if (checkSelection(item)) {
            <mat-option class="hide-checkbox" [ngClass]="{'notranslate':disableTranslation}" id="{{'singleselect-'+displayKey?item[displayKey]:item}}" [value]="valueKey?item[valueKey]:item" (click)="toggleSelection(item)">
            {{displayKey?item[displayKey]:item}}</mat-option>
          }
        }
      </div>
    }
    @if (emptyResults) {
      <div class="selectedOptionsList">
        <mat-option class="hide-checkbox" [disabled] ="emptyResults" class="hide-checkbox">
          {{noEntriesFoundLabel}}
        </mat-option>
      </div>
    }
  </mat-select>
</mat-form-field>
